// Common React Hook Form error types
export const RHF_ERROR_TYPES = [
  'required',
  'min',
  'max',
  'minLength',
  'maxLength',
  'pattern',
  'validate',
  'custom',
] as const;
